import { fetchAuthSession } from 'aws-amplify/auth';

export function getBaseUrl(): string {
  return process.env.NODE_ENV === 'development'
    ? '/Prod'
    : (process.env.REACT_APP_API_BASE_URL || 'https://p811zb8knk.execute-api.us-east-1.amazonaws.com/Prod');
}

export async function getAuthHeaders(): Promise<Record<string, string>> {
  const session = await fetchAuthSession();
  const idToken = session.tokens?.idToken?.toString();
  if (!idToken) throw new Error('Not authenticated');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${idToken}`,
  };
}
